import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import { StyledToggleButtonGroup } from "./partial/StyledToggleButtonGroup.partial";
import { StyledToggleButton } from "./partial/StyledToggleButton.partial";
import { useTranslation } from "react-i18next";

type P = {
  departmentData: { id: string; name: string }[];
  /** state for temp department selection */
  departmentSelected: { id: string; name: string }[];
  /** redux state for department selection */
  selectedDepartmentIds: string[] | undefined;
  handleDepartmentSelect: (e: any, value: { id: string; name: string }[]) => void;
};

export function DepartmentSelector2({
  departmentData,
  departmentSelected,
  selectedDepartmentIds,
  handleDepartmentSelect
}: Readonly<P>) {
  const { t } = useTranslation();
  const [newToggles, setNewToggles] = useState<{ id: string; name: string }[]>([]);
  const [option, setOption] = useState<{ id: string; name: string }[]>([]);
  const [initialized, setInitialized] = useState(false);

  /** Value for ToggleButtonGroup must use same refs as button values (from option), so we derive by id. */
  const valueForGroup = option.filter(opt => newToggles.some(togg => togg.id === opt.id));

  function handleDepartmentToggle(e: any, selected: { id: string; name: string }[]) {
    const selectedIds = new Set(selected.map(s => s.id));
    const normalized = option.filter(opt => selectedIds.has(opt.id));
    setNewToggles(normalized);
    handleDepartmentSelect(e, normalized);
  }

  useEffect(() => {
    if (departmentData.length > 0) {
      setOption(departmentData);
      setInitialized(true);
    }
  }, [departmentData]);

  useEffect(() => {
    if (!initialized) return;

    // check if already selected exists
    if (departmentSelected?.length && selectedDepartmentIds?.length) {
      setNewToggles(option.filter(opt => departmentSelected.some(sel => sel.id === opt.id)));
      setInitialized(false);
    } else setInitialized(false);
  }, [initialized]);

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column" }}
      data-testid="capacity-department-selector-box"
    >
      {/* weekdays toggle button group */}
      <StyledToggleButtonGroup
        value={valueForGroup}
        onChange={handleDepartmentToggle}
        orientation={"vertical"}
      >
        {option.length > 0 &&
          option.map(opt => (
            <StyledToggleButton
              key={opt.id}
              disableRipple
              value={opt}
              selected={valueForGroup.some(togg => togg.id === opt.id)}
              data-testid={`capacity-report-department-${opt.name}-toggle-btn`}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {valueForGroup.some(togg => togg.id === opt.id) ? (
                  <CheckBox />
                ) : (
                  <CheckBoxOutlineBlank />
                )}
                {opt.name}
              </Box>
            </StyledToggleButton>
          ))}

        {/* when not initialized yet or no options avaiable */}
        {!option.length && (
          <Box sx={{ p: 1 }}>
            <Typography>{t("No {{title}} to display", { title: t("department") })}</Typography>
          </Box>
        )}
      </StyledToggleButtonGroup>
    </Box>
  );
}
